// core
import { AppComponent } from '../app.component';
// import { ControlComponent } from "./Core/control/control.component";
import { BaseComponent } from './base.component';

// layout
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { PopupCompoentnt } from './layout/popup/popup.component';
import { ContentComponent } from './layout/content/content.component';
import { InterviewComponent } from './layout/interview/interview.component';
import { SideBarComponent } from './layout/sidebar/sidebar.component';
import { floaterComponent } from './layout/floater/floater.component';
import { ModalComponent } from './layout/modal/modal.component';
import { ProgressAccordionComponent } from './layout/progress-accordion/progress-accordion.component';
import { LoaderComponent } from './layout/loader/loader.component';
// general
import { UnMaskedComponent } from './general/unmasked-input/unmasked-input.component';
import { AlarmSystemComponent } from './general/alarm-system/alarm-system.component';
import { MaskedComponent } from './general/masked-input/masked-input.component';
import { ButtonLinkComponent } from './general/button-link/button-link.component';
import { RoundchevronComponent } from './general/round-chevron/roundchevron.component';
import { CustomHtmlCompnent } from './general/custom-html/custom-html.component';
import { SubSectionTitleComponent } from './general/sub-section-title/sub-section-title.component';
import { CustomTitle3Component } from './general/CustomTitle3/custom-title-3.component';
import { ProgressMeterComponent } from './general/progressmeter/progressmeter.component';
import { WellCarrierComponent } from './general/well-carrier/well-carrier.component';
import { CheckBoxComponent } from './general/Checkbox/check-box.component';
import { QuestionComponent } from './general/question/question.component';
import { TooltipComponent } from './general/tooltip/tooltip.component';
import { AuditingComponent } from './general/auditing/auditing.component';
import { SectiontitleComponent } from './general/section-title/section-title.components';
import { CustomButtonComponent } from './general/custom-button/custom-button.compoenent';
import { CustomButtonListComponent } from './general/custom-button-list/custom-button-list.component';
import { NumericStepperComponent } from './general/numeric-stepper/numeric-stepper.component';
import { MoreButtonComponent } from './general/more-button/more-button.component';
import { RoundImageContainerComponent } from './general/round-image-container/round-image-container.component';
import { RoundImageComponent } from './general/round-image/round-image.component';
import { RoundImageMultiSelectComponent } from './general/round-image-multiselect/round-image-multiselect';
import { RadioButtonCompoent } from './general/radio-button/radio-button.component';
import { RadioCompoent } from './general/radio/radio.component';
import { DatepickerComponent } from './general/datepicker/datepicker.component';
import { DatepickerAccessibilityComponent } from './general/datepicker-accessibility/datepicker-accessibility.component';
import { AddressComponent } from './general/address/address.component';
import { PopoverAddressComponent } from './general/popover-address/popover-address.component';
import { DropDownComponent } from './general/dropdown/dropdown.components';
import { InsertNumberComponent } from './general/insert-number/insert-number.component';
import { CustomTextAreaComponent } from './general/custom-textarea/custom-textarea.component';
import { SepComponent } from './general/sep/sep.component';
import { CustomIconComponent } from './general/custom-icon/custom-icon.component';
import { ExistingAccountAccountComponent } from './general/existing-account/existing-account.component';
import { StyledButtonComponent } from './general/styled-button/styled-button.component';
import { StyledButtonsComponent } from './general/styled-buttons/styled-buttons.component';
import { QuestionGroupComponent } from './general/question-group/question-group.component';
import { FilledDataComponent } from './general/filled-data/filled-data.components';
import { PreloaderComponent } from './general/preloader/preloader.component';
import { ComparisonComponent } from './general/comparison/comparison.component';
import { InfoWeFoundComponent } from './general/info-we-found/info-we-found.component';
import { ExtendedInfoWeFoundComponent } from './general/extended-info-we-found/extended-info-we-found.component';
import { TalkWithusComponent } from './general/talk-with-us/talk-with-us.component';
import { SchedulepanelComponent } from './general/schedule-panel/schedule-panel.component';
import { QuoteComponent } from './general/Quote/Quote.component';
import { QuoteWithInfoProviderComponent } from './general/quote-with-provider-info/quote-with-provider-info.component';
import { CallMeNowComponent } from './general/call-me-now/call-me-now.component';
import { ProviderInfoComponent } from './general/provider-info/provider-info.component';
import { InfoBlockComponent } from './general/info-block/info-block.component';
import { CallProgressiveComponent } from './general/call-progressive/call-progressive.component';
import { MapComponent } from './general/map/map.component';
import { ClickListItemComponent } from './general/click-list-item/click-list-item.component';
import { MultiSelectComponent } from './general/multiselect/multiselect.component';
import { BreakComponent } from './general/break/break.component';
import { ClickListeningComponent } from './general/click-listening/click-listening.component';
import { ContentBorderComponent } from './general/content-border/content-border.component';
import { SecondaryOnlineBuyComponent } from './general/secondary-online-buy/secondary-online-buy.component';
import { TooltipHandlerComponent } from './general/tooltip-handler/tooltip-handler.component';
import { CoveragePackagesComponents } from './general/coverage-packages/coverage-packages.components';
import { UnderWrittenComponent } from './general/under-written/under-written.component';
import { UpperSectionDrComponent } from './mpq3-dr/components/upper-section-dr/upper-section-dr.component';
import { AddressDisplayDrComponent } from './mpq3-dr/components/address-display-dr/address-display-dr.component';
import { AddressCompareComponent } from './mpq3-dr/components/address-compare/address-compare.component';
import { InfoWeFoundMvpComponent } from './general/info-we-found-mvp/info-we-found-mvp.component';
import { BuyingOptionsComponent } from './general/buying-options/buying-options.component';
import { MultiCheckboxComponent } from './general/multi-checkbox/multi-checkbox.component';
import { PreferencesRankingComponent } from './general/preferences-ranking/preferences-ranking.component';
import { CustomeScriptInjectionHtmlComponent } from './general/custome-script-injection-html/custome-script-injection-html.component';
import { DiscountCheckboxComponent } from './mpq3-dr/components/discount-checkbox/discount-checkbox.component';
import { KickoutMfhExpertBoxComponent } from './general/kickout-mfh-expert-box/kickout-mfh-expert-box.component';
import { KickoutMfhCarrierBoxComponent } from './general/kickout-mfh-carrier-box/kickout-mfh-carrier-box.component';
import { ResultPageToggleSectionComponent } from './layout/result-page-toggle-section/result-page-toggle-section.component';
import { CarriersBenefitsPopupComponent } from './general/carriers-benefits-popup/carriers-benefits-popup.component';
import { RatesDropdownComponent } from './general/rates-dropdown/rates-dropdown.component';

export const componentMap = {
	header: HeaderComponent,
	'app-root': AppComponent,
	popup: PopupCompoentnt,
	interview: InterviewComponent,
	// control: ControlComponent,
	'unmasked-input': UnMaskedComponent,
	'alarm-system': AlarmSystemComponent,
	'masked-input': MaskedComponent,
	sidebar: SideBarComponent,
	'progress-meter': ProgressMeterComponent,
	floater: floaterComponent,
	'round-chevron': RoundchevronComponent,
	SubSectionTitle: SubSectionTitleComponent,
	'custom-title-3': CustomTitle3Component,
	WellCarrier: WellCarrierComponent,
	'custom-html': CustomHtmlCompnent,
	'custom-script-injection-html': CustomeScriptInjectionHtmlComponent,
	Checkbox: CheckBoxComponent,
	Content: ContentComponent,
	question: QuestionComponent,
	tooltip: TooltipComponent,
	auditing: AuditingComponent,
	SectionTitle: SectiontitleComponent,
	'button-link': ButtonLinkComponent,
	'custom-button': CustomButtonComponent,
	'custom-button-list': CustomButtonListComponent,
	'numeric-stepper': NumericStepperComponent,
	'more-button': MoreButtonComponent,
	'round-image-container': RoundImageContainerComponent,
	'round-image': RoundImageComponent,
	'radio-button': RadioButtonCompoent,
	radio: RadioCompoent,
	Datepicker: DatepickerComponent,
	DatepickerAccessibility: DatepickerAccessibilityComponent,
	footer: FooterComponent,
	address: AddressComponent,
	'popover-address': PopoverAddressComponent,
	// "address-subcontrol": AddressSubControlComponent,
	'drop-down': DropDownComponent,
	'rates-dropdown': RatesDropdownComponent,
	'insert-number': InsertNumberComponent,
	modal: ModalComponent,
	'custom-textarea': CustomTextAreaComponent,
	sep: SepComponent,
	'custom-icon': CustomIconComponent,
	'existing-account': ExistingAccountAccountComponent,
	'progress-accordion': ProgressAccordionComponent,
	'round-image-multiselect': RoundImageMultiSelectComponent,
	'styled-button': StyledButtonComponent,
	'styled-buttons': StyledButtonsComponent,
	'question-group': QuestionGroupComponent,
	'filled-data': FilledDataComponent,
	preloader: PreloaderComponent,
	comparison: ComparisonComponent,
	'info-we-found': InfoWeFoundComponent,
	'info-we-found-mvp': InfoWeFoundMvpComponent,
	'extended-info-we-found': ExtendedInfoWeFoundComponent,
	'talk-with-us': TalkWithusComponent,
	'schedule-panel': SchedulepanelComponent,
	quote: QuoteComponent,
	QuoteWithInfoProvider: QuoteWithInfoProviderComponent,
	'call-me-now': CallMeNowComponent,
	'provider-info': ProviderInfoComponent,
	'info-block': InfoBlockComponent,
	'call-progressive': CallProgressiveComponent,
	CarriersBenefitsPopup: CarriersBenefitsPopupComponent,
	map: MapComponent,
	'click-list-item': ClickListItemComponent,
	loader: LoaderComponent,
	'multi-select': MultiSelectComponent,
	break: BreakComponent,
	'click-listening': ClickListeningComponent,
	'content-border': ContentBorderComponent,
	'secondary-online-buy': SecondaryOnlineBuyComponent,
	'coverage-packages': CoveragePackagesComponents,
	'under-written': UnderWrittenComponent,
	UpperSectionDr: UpperSectionDrComponent,
	AddressDisplayDr: AddressDisplayDrComponent,
	AddressCompare: AddressCompareComponent,
	'buying-options': BuyingOptionsComponent,
	'multi-checkbox': MultiCheckboxComponent,
	'preferences-ranking': PreferencesRankingComponent,
	'discount-checkbox': DiscountCheckboxComponent,
	'kickout-mfh-expert': KickoutMfhExpertBoxComponent,
	'kickout-mfh-carrier': KickoutMfhCarrierBoxComponent,
	'result-page-toggle-section': ResultPageToggleSectionComponent,
};

export const allComponents = [Object.keys(componentMap).map((itm) => componentMap[itm]), InterviewComponent];

export const allEntryComponents = [
	ModalComponent,
	BaseComponent,
	AppComponent,
	HeaderComponent,
	FooterComponent,
	PopupCompoentnt,
	ContentComponent,
	InterviewComponent,
	SideBarComponent,
	floaterComponent,
	ProgressAccordionComponent,
	LoaderComponent,
	UnMaskedComponent,
	AlarmSystemComponent,
	MaskedComponent,
	ButtonLinkComponent,
	RoundchevronComponent,
	CustomHtmlCompnent,
	CustomeScriptInjectionHtmlComponent,
	SubSectionTitleComponent,
	CustomTitle3Component,
	ProgressMeterComponent,
	WellCarrierComponent,
	CheckBoxComponent,
	QuestionComponent,
	TooltipComponent,
	AuditingComponent,
	SectiontitleComponent,
	CustomButtonComponent,
	CustomButtonListComponent,
	NumericStepperComponent,
	MoreButtonComponent,
	RoundImageContainerComponent,
	RoundImageComponent,
	RoundImageMultiSelectComponent,
	RadioButtonCompoent,
	RadioCompoent,
	DatepickerComponent,
	DatepickerAccessibilityComponent,
	AddressComponent,
	PopoverAddressComponent,
	DropDownComponent,
	RatesDropdownComponent,
	InsertNumberComponent,
	CustomTextAreaComponent,
	SepComponent,
	CustomIconComponent,
	ExistingAccountAccountComponent,
	StyledButtonComponent,
	StyledButtonsComponent,
	QuestionGroupComponent,
	FilledDataComponent,
	PreloaderComponent,
	ComparisonComponent,
	InfoWeFoundComponent,
	InfoWeFoundMvpComponent,
	ExtendedInfoWeFoundComponent,
	TalkWithusComponent,
	SchedulepanelComponent,
	QuoteComponent,
	QuoteWithInfoProviderComponent,
	CallMeNowComponent,
	ProviderInfoComponent,
	InfoBlockComponent,
	CallProgressiveComponent,
	CarriersBenefitsPopupComponent,
	MapComponent,
	ClickListItemComponent,
	MultiSelectComponent,
	BreakComponent,
	ClickListeningComponent,
	ContentBorderComponent,
	SecondaryOnlineBuyComponent,
	TooltipHandlerComponent,
	CoveragePackagesComponents,
	UnderWrittenComponent,
	UpperSectionDrComponent,
	AddressDisplayDrComponent,
	AddressCompareComponent,
	BuyingOptionsComponent,
	MultiCheckboxComponent,
	PreferencesRankingComponent,
	DiscountCheckboxComponent,
	KickoutMfhCarrierBoxComponent,
	KickoutMfhExpertBoxComponent,
	ResultPageToggleSectionComponent,
];
